import React, { useState, useEffect, forwardRef } from "react";
import MaterialTable from "material-table";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import PatchedPagination from "../../layout/MTPagination";

const PaymentTable = ({
  paymentItems,
  setOpenDetails,
  checked1,
  checked2,
  checked3,
  checked4,
}) => {
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  //set rows data
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setRows([]);
    if (paymentItems) {
      let selectedPaymentType = [];
      if (checked1) {
        selectedPaymentType.push("PAYPAL_EXPRESS");
      }
      if (checked2) {
        selectedPaymentType.push("PAYPAL_BILLING_AGREEMENT");
      }
      if (checked3) {
        selectedPaymentType.push("VISA");
      }
      if (checked4) {
        selectedPaymentType.push("MASTER");
      }
      for (let x in paymentItems) {
        let each = paymentItems[x];
        if (selectedPaymentType.includes(each.payment_type)) {
          setRows((rows) => [
            ...rows,
            {
              create_time: each.create_time,
              id: each.id,
              status: each.status,
              gross: each.gross + " USD",
              fee: "-" + each.fee + " USD",
              net: each.net + " USD",
              shopify: each.shopify,
              payment_type: each.payment_type,
            },
          ]);
        }
      }
    }
  }, [paymentItems, checked1, checked2, checked3, checked4]);

  const rowEvents = (event, rowData) => {
    setOpenDetails(rowData);
  };

  const column = [
    {
      field: "create_time",
      title: "Date",
      cellStyle: {
        width: 200,
        minWidth: 200,
        fontSize: 12,
      },
    },
    {
      field: "id",
      title: "Transaction ID",
      cellStyle: {
        width: 200,
        minWidth: 200,
        fontSize: 12,
      },
    },
    {
      field: "status",
      title: "Payment",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
      },
    },
    {
      field: "shopify",
      title: "Shopify",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
      },
    },
    {
      field: "gross",
      title: "Gross",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
      },
    },
    {
      field: "fee",
      title: "Fee",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
      },
    },
    {
      field: "net",
      title: "Net",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
      },
    },
  ];

  return (
    <MaterialTable
      columns={column}
      data={rows}
      icons={tableIcons}
      onRowClick={(event, rowData) => rowEvents(event, rowData)}
      options={{
        search: false,
        sorting: true,
        pageSizeOptions: [10, 25, 50],
        pageSize: 10,
        padding: "dense",
        showTitle: false,
        toolbar: false,
        draggable: false,
        headerStyle: {
          fontWeight: "bold",
          fontSize: 12,
          zIndex: 0,
        },
      }}
      components={{
        Pagination: PatchedPagination,
      }}
    />
  );
};

export default PaymentTable;
